import React, { createContext, useContext, useMemo } from 'react';
import BiLoggerFactory, { type Logger } from '@wix/fe-essentials-standalone/bi';

export interface IBiContext {
  logger: Logger;
}

export const BiContext = createContext<IBiContext>({
  logger: null,
});

export const BiContextProvider = ({ children }) => {
  const logger = useMemo(() => BiLoggerFactory.factory().logger(), []);

  return <BiContext.Provider value={{ logger }}>{children}</BiContext.Provider>;
};

export const useBiLogger = () => useContext(BiContext);
